import { NextPage } from 'next';
import BrandingPage from '@sy/app-client/src/ssrAdapter/pages/BrandingPage';

import MarketingTemplate from '~/components/templates/MarketingTemplate';
import buildMetatadata from '~/utils/buildMetadata';
import { getMarketingNavigation } from '~/utils/getNavigation';
import { translate, buildGetServerSideProps } from '../getServerSideProps';
import type { CommonContext, InferProps } from '../getServerSideProps';

const Branding: NextPage<InferProps<typeof getServerSideProps>> = ({
	navigation,
	user,
}) => (
	<MarketingTemplate activePage="/branding" navigation={navigation} user={user}>
		<BrandingPage />
	</MarketingTemplate>
);

const customServerSideProps = async (context: CommonContext) => {
	const { featureFlags, locale, query } = context;

	return {
		props: {
			metadata: buildMetatadata({
				title: translate(locale, 'common.title.brandedStreams'),
			}),
			navigation: await getMarketingNavigation({ featureFlags, locale, query }),
		},
	};
};

export const getServerSideProps = buildGetServerSideProps({
	customServerSideProps,
	translationNamespaces: ['common', 'auth', 'landing', 'landingBrandedStreams'],
});

export default Branding;
